<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em>No associated divisions</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let division">
				{{ division.name }}
			</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
			<td mat-cell *matCellDef="let division">
				{{ division.status }}
			</td>
		</ng-container>

		<ng-container matColumnDef="subdivisions">
			<th mat-header-cell *matHeaderCellDef>Subdivisions</th>
			<td
				mat-cell
				*matCellDef="let division; let i = index"
				[formGroupName]="findDivisionIndex(division)"
			>
				<rpfsa-subdivision-list
					formControlName="subdivisions"
				></rpfsa-subdivision-list>
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let division; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editDivision(division)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let division; let i = index">
				<button
					type="button"
					mat-icon-button
					color="warn"
					[guard]="canDeleteDivision(division)"
					rpsharedConfirm="Delete division?"
					(onConfirmed)="array.removeAt(findDivisionIndex(division))"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let division; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator
			class.hidden="true"
			pageSize="5"
			[pageSizeOptions]="[5, 10]"
		></mat-paginator>
		<div>
			<button
				type="button"
				class="mr-4"
				(click)="uploadDivisions()"
				mat-mini-fab
				color="primary"
				matTooltip="Upload Divisions"
			>
				<mat-icon>upload</mat-icon>
			</button>
			<button
				type="button"
				class="mr-4"
				(click)="addDivision()"
				mat-mini-fab
				color="primary"
				matTooltip="Add Division"
			>
				<mat-icon>add</mat-icon>
			</button>
		</div>
	</div>
</ng-container>
